import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../profile.service';
import { ProfileOutputService } from '../profile-output/profile-output.service';
import { ConfigurationHandlerService } from '../../core/configuration-handler.service';
import { ProfileComponent } from '../profile.component';
import { ProfileActivationComponent } from '../../profile-activation/profile-activation.component';

@Component({
    selector: 'esp-profile-standalone',
    templateUrl: './profile-standalone.component.html',
    styleUrls: ['./profile-standalone.component.scss'],
    imports: [ProfileActivationComponent, ProfileComponent],
})
export class ProfileStandaloneComponent implements OnInit {
    private route = inject(ActivatedRoute);
    profileService = inject(ProfileService);
    profileOutputService = inject(ProfileOutputService);
    private configurationHandlerService = inject(ConfigurationHandlerService);

    @HostBinding('class.exl-layout--header-main-footer') layoutClass = true;

    showActivationProfile = true;

    ngOnInit() {
        this.profileOutputService.cleanFacets();
        this.profileService.isPublicPage = false;
        this.route.params.subscribe((params) => {
            if (params && params['id']) {
                this.profileService.isPublicPage = true;
                this.profileService.userID = params['id'];
            }
        });
        if (
            !this.configurationHandlerService.isEsploroEditionAdvanced() ||
            !this.configurationHandlerService.researcherProfileGeneralConfiguration()
                .activateProfile ||
            this.profileService.isPublicPage
        ) {
            this.showActivationProfile = false;
        }
    }
}
